const dependencyViewTemplate = `
<div>
   <div  class="container">
        <div style="display:none">
        <canvas id="plusIcon" ></canvas>
		<canvas id="leafIcon" ></canvas>
		<canvas id="minusIcon"></canvas>
		</div>
       <div class="row">
           <h2 class="gridh2">{{projectName}} [ {{projectVersion}} ] Dependencies</h2>
           <table class="table table-striped">
                <thead>
                    <tr>
                        <td>Dependency</td>
                        <td>Version</td>
                        <td>Resolved</td>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in tree | dependencyTreeItem:itemName:isExpand">
                        <td>
                            <span style="padding-left: {{item.level * 30}}px;">
                                <span class="glyphicon" ng-click="itemClick(item.name, item.expand);"
                                  ng-class="{'glyphicon-minus': !item.leaf && item.expand, 'glyphicon-plus': !item.leaf && !item.expand, 'glyphicon-leaf': item.leaf}">
                                </span>
                                {{item.name}}
                            </span>
                        </td>
                        <td>{{item.version}}</td>
                        <td>{{item.resolved}}</td>

                    </tr>
                </tbody>
           </table>
       </div>
   </div>
</div>
`;
export default dependencyViewTemplate;
